module.exports = __webpack_public_path__ + "img/12.0d78751d.png";